import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import PaymentAsso from '../../Components/Binding';
import { I18n } from 'react-redux-i18n';
import ProductThreshold from '../../Components/ProductQuantity';
import Options from '../../Components/Options';
import Config from '../../Components/Config';
import { getPartner, getExportActive } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import Export from '../../Components/Export';
import SupplementManager from '../../Components/SupplementExtra';
import { deepEqual } from '../../utils';
import ButtonPayPlus from '../LadditionTicket/Components/ButtonPayPlus';
import PartnerTaxRate from '../../Components/PartnerTaxRate';

class CommandeEnLigne extends Component {
	shouldComponentUpdate(nextProps) {
		if (deepEqual(this.props.list, nextProps.list)) {
			return false;
		}

		return true;
	}

	render() {
		const { partner } = this.props;

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<Export {...this.props} />
				<div className="gestion-button">
					<SupplementManager prefix={partner.prefix} />
					<PaymentAsso prefix={partner.prefix} />
					<PartnerTaxRate prefix={partner.prefix} />
					<ButtonPayPlus prefix={partner.prefix} />
					<ProductThreshold prefix={partner.prefix} />
				</div>

				<Options prefix_partner={partner.prefix || ''} />
				<Config prefix_partner={partner.prefix || ''} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	return {
		partner,
		list: state.exports.list,
	};
};

export default connect(mapStateToProps)(CommandeEnLigne);
